export default __webpack_public_path__ + "static/media/1144.16110cb4.png";